import React from 'react';

const Table = ({ titles, subscriptions }) => {
	return (
		<>
			<table>
				<thead>
					<tr>{ titles.map(([title, ]) => <th key={title}>{title}</th>) }</tr>
				</thead>
				<tbody>
					{
						subscriptions.map(subscription => {
							return <tr key={subscription.id}>
								{
									titles.map(([, attribute]) => {
										return (<td key={subscription.id + '_' + attribute}>
											{subscription[attribute]}
										</td>);
									})
								}
							</tr>;
						})
					}
				</tbody>
			</table>
		</>
	);
};

export default Table;
